module.exports = __webpack_public_path__ + "assets/img/help_closebtn.5f7c9c38.svg";